
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_145pa_1tu4q_9",
  "focus-lock": "awsui_focus-lock_145pa_1tu4q_41",
  "calendar": "awsui_calendar_145pa_1tu4q_45",
  "date-picker-container": "awsui_date-picker-container_145pa_1tu4q_61",
  "date-picker-trigger": "awsui_date-picker-trigger_145pa_1tu4q_66",
  "date-picker-input": "awsui_date-picker-input_145pa_1tu4q_70",
  "open-calendar-button": "awsui_open-calendar-button_145pa_1tu4q_75"
};
  